const dev = {
  API_ENDPOINT_URL: 'http://localhost:8080',
  OAUTH2_REDIRECT_URI: 'http://localhost:3000/oauth2/redirect',
  PAYPAL_CLIENT_ID: 'ASIDMUga1PrDyJwKBzzrsrefoIoZQy9ImUl-437e2dlqephBVRq8bj9GOrOGWmPn4z-qujZNKI_jPn7l',
  CONFIRMACAO_PRESENCA_URL: 'http://localhost:3000/confirmacao-presenca',
};

const prod = {
  API_ENDPOINT_URL: 'https://osbeautys-api.pedroamaral.dev.br',
  OAUTH2_REDIRECT_URI: 'https://app.gopartyeventos.com.br/oauth2/redirect',
  PAYPAL_CLIENT_ID: 'AQwaXoGej9j_Zg40jlDEOrH2qnsC70E0uHOmUiMgVLLuAHJv-egMn7kZZP9zdNjgxAXpN6Dsht1o2OTc',
  CONFIRMACAO_PRESENCA_URL: 'https://app.gopartyeventos.com.br/confirmacao-presenca',
};

const test = {
  API_ENDPOINT_URL: 'http://localhost:8080',
  OAUTH2_REDIRECT_URI: 'http://localhost:3000/oauth2/redirect',
  PAYPAL_CLIENT_ID: 'ASIDMUga1PrDyJwKBzzrsrefoIoZQy9ImUl-437e2dlqephBVRq8bj9GOrOGWmPn4z-qujZNKI_jPn7l',
  CONFIRMACAO_PRESENCA_URL: 'http://localhost:3000/confirmacao-presenca',
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
